import { useTranslation } from 'react-i18next';

import BioscopeCamera from '@/assets/icons/bioscope_camera.svg?component';
import InformationLine from '@/assets/icons/information_line.svg?component';
import { Caption } from '@/components/atoms/Eyebrow';
import SkeletonBox from '@/components/atoms/SkeletonBox/SkeletonBox';
import TitleIcon from '@/components/atoms/TitleIcon/TitleIcon';
import ContentBlock from '@/components/molecules/ContentBlock';
import type { PenOverview } from '@/domain/operationalDashboard';

import styles from './OperationalSidebar.module.scss';

interface OperationalSidebarProps {
    penOverview?: PenOverview;
    isLoading: boolean;
}

export default function OperationalSidebar(props: OperationalSidebarProps) {
    const { penOverview, isLoading } = props;
    const { t } = useTranslation();

    const measuringCount =
        penOverview?.pens.filter((p) => p.bioscopeStatus === 'measuring').length ?? 0;
    const totalBioscopes = penOverview?.pens.filter((p) => p.bioscopeId != null).length ?? 0;

    return (
        <ContentBlock>
            <div className={styles.sidebarBox}>
                <div className={styles.sidebarRow}>
                    <TitleIcon icon={BioscopeCamera} tone="neutral" />
                    <div className={styles.sidebarTextGroup}>
                        <Caption as="div">
                            {t('operationalDashboard.sidebar.bioscopeStatus')}
                        </Caption>
                        <div className={styles.sidebarValue}>
                            {isLoading ? (
                                <SkeletonBox width={140} height={18} />
                            ) : (
                                <>
                                    <span className={styles.sidebarValueHighlight}>
                                        {measuringCount}/{totalBioscopes}
                                    </span>{' '}
                                    {t('operationalDashboard.sidebar.bioscopesMeasuring')}
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className={styles.sidebarSeparator} />

                <div className={styles.informationRow}>
                    <TitleIcon icon={InformationLine} />
                    <div>
                        <div className={styles.informationTitle}>
                            {t('operationalDashboard.sidebar.information')}
                        </div>
                    </div>
                </div>
                <div className={styles.informationText}>
                    {t('operationalDashboard.sidebar.informationText')}
                </div>
            </div>
        </ContentBlock>
    );
}
